import React, { useCallback, useState } from 'react';
import { ArrowRightIcon } from 'lucide-react';
import { DiamondIcon } from '../components/diamond/DiamondIcon';
import { BclPlayer } from '../components/diamond/BclPlayer';
import { LegalModal } from '../components/legal/LegalModal';
import { PrivacyModal } from '../components/diamond/PrivacyModal';
import { nextStepUrl } from '../data/diamond';
import type { LegalDocId } from '../data/legal';
export function DiamondMethod() {
  const [legalId, setLegalId] = useState<LegalDocId | null>(null);
  const closeLegal = useCallback(() => setLegalId(null), []);
  const [privacyOpen, setPrivacyOpen] = useState(false);
  const closePrivacy = useCallback(() => setPrivacyOpen(false), []);
  const hasLink = nextStepUrl.length > 0;
  return <div className="flex min-h-screen w-full flex-col bg-void font-sans text-white" data-id="element-297" data-mp="3409xc76pelzl">
      <header className="flex justify-center px-6 pt-8 sm:pt-10" data-id="element-298" data-mp="1nim4nza8mdyo">
        <span className="flex items-center gap-2.5 text-sm font-semibold tracking-[0.4em] text-white" data-id="element-299" data-mp="1sk1r9vs2csj6">
          <DiamondIcon className="h-4 w-4 text-white/80" data-id="element-300" data-mp="1mjexd0ogjpqh" />
          JSEEFECT
        </span>
      </header>

      <main className="flex flex-1 flex-col items-center px-5 pb-20 pt-16 sm:px-8 sm:pt-24" data-id="element-301" data-mp="1ii3fxifqmatd">
        <div className="flex flex-col items-center text-center" data-id="element-302" data-mp="1whl1loxql7yi">
          <p className="text-xs font-medium tracking-[0.45em] text-white/55 sm:text-sm" data-id="element-303" data-mp="1rhq77ber608p">DESCUBRE EL</p>
          <h1 className="mt-6 flex flex-col items-center" data-id="element-304" data-mp="25gpwmla3aj5x">
            <span className="text-6xl font-extrabold leading-none tracking-tight sm:text-8xl lg:text-9xl" data-id="element-305" data-mp="25f51atfyaw70">
              JSEEFECT
            </span>
            <span className="mt-4 flex items-center gap-3 text-base font-light tracking-[0.4em] text-white/90 sm:mt-5 sm:text-2xl sm:tracking-[0.5em]" data-id="element-306" data-mp="2f7asi0ydp9l5">
              DIAMOND METHOD
              <DiamondIcon className="h-5 w-5 text-white sm:h-6 sm:w-6" data-id="element-307" data-mp="2p4yyjn1fq3im" />
            </span>
          </h1>
          <p className="mt-8 max-w-md text-base leading-relaxed text-white/65 sm:mt-10 sm:text-lg" data-id="element-308" data-mp="2k6nqnhupa331">
            No todos los cambios comienzan de la misma manera.
          </p>
        </div>

        <div className="mt-12 w-full max-w-4xl sm:mt-16" data-id="element-309" data-mp="2w85iig88srt3">
          <BclPlayer data-id="element-310" data-mp="2w8oqp583c1tx" />
        </div>

        <a href={hasLink ? nextStepUrl : '#'} onClick={e => {
        if (!hasLink) e.preventDefault();
      }} {...hasLink ? {
        target: '_blank',
        rel: 'noopener noreferrer'
      } : {}} className="group mt-12 inline-flex w-full max-w-md items-center justify-center gap-3 rounded-full bg-crimson px-8 py-5 text-sm font-semibold tracking-[0.18em] text-white transition-[background-color,transform] duration-150 ease-out hover:bg-crimson-hover active:scale-[0.98] focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-4 focus-visible:outline-white sm:mt-14 sm:w-auto sm:text-base" data-id="element-311" data-mp="317rvqpo2m81w">
          QUIERO DESCUBRIR MI SIGUIENTE PASO
          <ArrowRightIcon className="h-4 w-4 shrink-0 transition-transform duration-150 ease-out group-hover:translate-x-1" aria-hidden="true" data-id="element-312" data-mp="1uitbt4vrszsm" />
        </a>
      </main>

      <footer className="flex flex-col items-center gap-3 px-6 pb-10 text-center text-xs text-white/40" data-id="element-313" data-mp="1i93nfn3sp7f3">
        <nav aria-label="Legal" className="flex gap-6" data-id="element-314" data-mp="1d97mxxub3y4a">
          <button type="button" onClick={() => setPrivacyOpen(true)} className="transition-colors duration-150 ease-out hover:text-white/80" data-id="element-315" data-mp="1d7mr84w9a94u">
            Política de privacidad
          </button>
          <button type="button" onClick={() => setLegalId('terminos')} className="transition-colors duration-150 ease-out hover:text-white/80" data-id="element-316" data-mp="20ys8mohuh9h9">
            Términos y condiciones
          </button>
        </nav>
        <p data-id="element-317" data-mp="1r38b5xnmu2qe">© 2026 JSEEFECT. Todos los derechos reservados.</p>
      </footer>

      <LegalModal openId={legalId} onClose={closeLegal} onSwitch={setLegalId} data-id="element-318" data-mp="kmmtmru9tby3" />
      <PrivacyModal open={privacyOpen} onClose={closePrivacy} data-id="element-319" data-mp="fkxgn6nhmo7d" />
    </div>;
}